import React from 'react';
import ReactDOM from 'react-dom';
import { MdClose } from "react-icons/md";
import Btn from '../buttons/buttons';
import s from "./modal.module.css";

function style (style){
  if(style==='button'){
    return 'pv-2 ph-3 pv-2@md ph-3@md  bg-orange-0 c-white'
  }
  else if (style==='link'){
    return 'c-orange-0 fw-1'
  }
  else if (style==='subtleLink'){
    return 'underline'
  }
  else if (style==='unstyled'){
    return ''
  }
}


export class Modal extends React.Component {
  constructor(props) {
    super(props);

    this.handleKeyUp = this.handleKeyUp.bind(this);
    /*this.handleOutsideClick = this.handleOutsideClick.bind(this);*/
  }

  componentDidMount() {
    window.addEventListener("keyup", this.handleKeyUp, false);
    document.addEventListener("click", this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    window.removeEventListener("keyup", this.handleKeyUp, false);
    document.removeEventListener("click", this.handleOutsideClick, false);
  }

  handleKeyUp(e) {
    const { onCloseRequest } = this.props;
    const keys = {
      27: () => {
        e.preventDefault();
        onCloseRequest();
        window.removeEventListener("keyup", this.handleKeyUp, false);
      }
    };

    if (keys[e.keyCode]) {
      keys[e.keyCode]();
    }
  }

  render() {
    const { onCloseRequest, children } = this.props;
    return ReactDOM.createPortal(
      <div className={`modalContent ${s.modal} ${this.props.stickAtTop ? s.stickAttop : null}`}>
        <div  className={`bg-white ${s.content} ${s[this.props.size]}`} ref={node => (this.modal = node)}>
          {
            this.props.onCloseRequest ?
              <button
                className={`brad-pill bg-orange-0 ${s.closeButton}`}
                type="button"
                onClick={onCloseRequest}><MdClose className='c-white' size='1.5em'
              /></button>
            : null
          }
          <div className={`${this.props.removePadding ? '' : 'pa-4 pl-4 pr-4 pb-4 pt-4'}   ${s.modalOverflow}`}>
            {children}
            {
              this.props.addBottomCLose ?
                <div className='center mv-4 '>
                  <Btn label='Calcular' size='medium' onClick={onCloseRequest} type='button'/>
                </div>
                : null
            }
          </div>
        </div>
      </div>, document.body
    );
  }
}

class ModalLauncher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  handleToggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }

  render() {
    const { buttonLabel, children } = this.props;
    const { showModal } = this.state;

    return (
      <React.Fragment>

      {
        this.props.styleButton === 'link' ||  this.props.styleButton === 'subtleLink' ||  this.props.styleButton === 'unstyled' ?
          <div className='dib dc'>
            <button
              id={this.props.id || undefined}
              type="button"
              className={`${style(this.props.styleButton)} ${this.props.className}`}
              onClick={() => this.handleToggleModal()}
            >
              {buttonLabel}
            </button>
          </div>
            :
            <Btn
              id={this.props.id || undefined}
              className={this.props.className}
              label={buttonLabel}
              onClick={() => this.handleToggleModal()}
              type='button'
              isPill={this.props.isPill}
              color={this.props.color}
              size={this.props.size}
            />

      }

        {showModal && (
          <Modal addBottomCLose={this.props.addBottomCLose} stickAtTop={this.props.stickAtTop} removePadding={this.props.removePadding} size={this.props.size} onCloseRequest={() => this.handleToggleModal()}>
            {children}
          </Modal>
        )}
    </React.Fragment>

    );
  }
}

ModalLauncher.defaultProps = {
  className: '',
  styleButton:'button',
  size:'fluid',
  color:'orange',
  isPill:false,
  removePadding: false,
  addBottomCLose:false,
  stickAtTop: false
};

export default ModalLauncher


